var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-manual",class:{ mobile: _vm.isMobile }},[_c('vue-pdf-app',{attrs:{"pageScale":"page-fit","pdf":_vm.pdf.src,"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }